module.exports = __webpack_public_path__ + "static/img/图层 588.a4d76da1.png";